module.exports = __webpack_public_path__ + "img/headercota.e42399f2.svg";